import React from "react";
import "./image-loop.css";
import LinearGoldText from "./linear-gold-text.tsx";
import ReviewItem from "./review-item.tsx";
import FeedbackList from "../images/feedback/feedback-list.json";

export default function CustomerReview({ isMobile }) {
  const brandLogo = [
    require("../images/pg9/pg9-logo.png"),
    require("../images/h4win/h4win-logo.png"),
    require("../images/rr4win/rr4win-logo.png"),
  ];

  const getImage = (brand) => {
    if (brand === "RR4") {
      return brandLogo[2];
    } else if (brand === "H4") {
      return brandLogo[1];
    } else {
      return brandLogo[0];
    }
  };

  const getRandomSample = () => {
    const result = [] as {
      name: string;
      rating: number;
      brand: string;
      review: string;
      id?: number;
    }[];
    const seenIndices = new Set();

    while (result.length < 50) {
      const randomIndex = Math.floor(Math.random() * FeedbackList.length);

      // Ensure we don't pick the same index twice
      if (!seenIndices.has(randomIndex)) {
        result.push({ ...FeedbackList[randomIndex], id: randomIndex });
        seenIndices.add(randomIndex);
      }
    }

    return result;
  };

  return (
    <div style={{ width: "100%" }}>
      <LinearGoldText isMobile={isMobile} style={{ marginBottom: "15px" }}>
        Customer Feedback
      </LinearGoldText>
      <div
        className="inner"
        style={{ minHeight: isMobile ? "165px" : "185px" }}
      >
        <div className="wrapper">
          <section>
            {getRandomSample().map(({ id, name, review, brand, rating }) => (
              <ReviewItem
                id={id}
                isMobile={isMobile}
                key={id}
                name={name}
                description={review}
                rating={Math.floor(rating)}
                logo={getImage(brand)}
              />
            ))}
          </section>
          <section>
            {getRandomSample().map(({ id, name, review, brand, rating }) => (
              <ReviewItem
                id={id}
                isMobile={isMobile}
                key={id}
                name={name}
                description={review}
                rating={Math.floor(rating)}
                logo={getImage(brand)}
              />
            ))}
          </section>
          <section>
            {getRandomSample().map(({ id, name, review, brand, rating }) => (
              <ReviewItem
                id={id}
                isMobile={isMobile}
                key={id}
                name={name}
                description={review}
                rating={Math.floor(rating)}
                logo={getImage(brand)}
              />
            ))}
          </section>
        </div>
      </div>
    </div>
  );
}
